import {Theme} from '@octavius-rocks/ui'
import {createUseStyles} from "react-jss";

export const useNavigationLinkStyles = createUseStyles({
    link: ({isActive}: {isActive: boolean})=>({
        display: "block",
        padding: Theme.space(3),
        background: isActive ? "white": Theme.colors.primary,
        textDecoration: "none",
        color: (!isActive)? Theme.colors.onPrimary: Theme.colors.primary,
        fontSize: "1rem",
        "&:focus":{
            outline: "none",
            color: (!isActive)? Theme.colors.onPrimary: "inherit",
        },
        "&:hover":{
            color: (!isActive)? Theme.colors.onPrimary: Theme.colors.primary,
        }
    })
})

export const useStyles = createUseStyles({
    root:{
    },
    nav:{
        borderBottom: "1px solid "+Theme.colors.primary,
    },
    navList:{
        display:"flex",
        marginBottom: 0,
    },
    navLi:{
        marginBottom: -1,
        marginLeft: Theme.space(4),
        border: "1px solid "+Theme.colors.primary,
        borderBottom: "none",
    },
    content:{
        background: "white",
        padding: Theme.space(4),
    }
})